// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostAsrFilterConfigMultilingualBody, BaseResponseVoid } from '../../types';

/**
 * saveMultilingual
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [POST] /asr-filter-config/multilingual
 */
export function postAsrFilterConfigMultilingual(
    data: PostAsrFilterConfigMultilingualBody
): Promise<BaseResponseVoid>;
export function postAsrFilterConfigMultilingual(
    data: PostAsrFilterConfigMultilingualBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postAsrFilterConfigMultilingual(
    data: PostAsrFilterConfigMultilingualBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostAsrFilterConfigMultilingualBody, never, never>(
        '/asr-filter-config/multilingual',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postAsrFilterConfigMultilingual',
        }
    );
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/multilingual',
        method: 'post',
    },
];
